// extracted by mini-css-extract-plugin
export default {"message":"Note_message__0cHRu","user":"Note_user__TNxHJ","time":"Note_time__COorS","pb20":"Note_pb20__CI30F"};